import { Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/TextLayer.css'; // Optional styles

const PDFViewer = ({ url }) => {
    return (
        <Document file={url}>
            <Page pageNumber={1} width={600}/>
        </Document>
    );
};

export default PDFViewer;
